module.exports = SharedDependencies.ClassNames['@local/application'];